import { render, staticRenderFns } from "./StandartBanner.vue?vue&type=template&id=12aaeeab"
import script from "./StandartBanner.vue?vue&type=script&lang=js"
export * from "./StandartBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports